import {t} from "react-switch-lang";

export const purposeOptions = [{value: 'PREVENTIVE', label: t('controls.preventive')}, {
    value: 'DETECTIVE', label: t('controls.detective')
}];

export const controlAssessmentOptions = [{
    value: 'SATISFACTORY', label: t('controls.satisfactory')
}, {
    value: 'NEEDS_IMPROVEMENT', label: t('controls.needs_improvement')
}, {
    value: 'UNSATISFACTORY', label: t('controls.unsatisfactory')
},]

export const controlTypeOptions = [{value: 'MANUAL', label: t('controls.manual')}, {
    value: 'AUTOMATED', label: t('controls.automated')
}, {value: 'SEMI_AUTOMATED', label: t('controls.semi_automated')}]

export const controlFrequencyOptions = [{value: 'DAILY', label: t('controls.daily')}, {
    value: 'WEEKLY', label: t('controls.weekly')
}, {
    value: 'MONTHLY', label: t('controls.monthly')
}, {
    value: 'QUARTERLY', label: t('controls.quarterly')
}, {
    value: 'HALF_YEARLY', label: t('controls.half_yearly')
}, {value: 'YEARLY', label: t('controls.yearly')}, {
    value: 'EVENT_BASED', label: t('controls.event_based')
}];